import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-60bc2d14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topbar-container" }
const _hoisted_2 = { class: "gorate-logo-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-logo-container" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require('@/assets/logos/gorate-logo.svg'),
        alt: "GoRate"
      }, null, 8, _hoisted_3)
    ]),
    _hoisted_4
  ]))
}